import { render } from "./hire_vehicle_master.vue?vue&type=template&id=06b350bc&scoped=true"
import script from "./hire_vehicle_master.vue?vue&type=script&lang=js"
export * from "./hire_vehicle_master.vue?vue&type=script&lang=js"

import "./hire_vehicle_master.vue?vue&type=style&index=0&id=06b350bc&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b350bc"]])

export default __exports__